import React, { useState, useEffect, useRef } from "react";
import { withRouter } from "react-router-dom";
import { Popover, Button } from "antd";
import "./menu.less";
import { lib } from "../index";
import {
    RightOutlined,
    BackwardOutlined,
    ForwardOutlined,
    MenuFoldOutlined,
    MenuUnfoldOutlined,
} from "@ant-design/icons";
import VerticalScroll from "../component/vertical-scroll";
import { env } from "@dt/util";
import FavoriteMenuModal from "../components/favorite-menu-modal";
import FavoriteMenu from "./favorite-menu";

export function openPage(url) {
    if (url.indexOf("http://") > -1 || url.indexOf("https://") > -1) {
        window.open(url);
    } else if (url) {
        url = url.replace("//", "/");
        lib.openPage(url);
    }
}

export const isMatch = (url, commonMenuFlag = false) => {
    let { systemPath } = env;
    url = url.replace("//", "/").split("?")[0];
    let pathname = window.location.pathname;
    return (
        pathname !== `/${systemPath}/` &&
        url !== `/${systemPath}/` &&
        pathname !== `/${systemPath}` &&
        url !== `/${systemPath}` &&
        pathname !== "" &&
        url !== "" &&
        pathname !== "/" &&
        url !== "/" &&
        url.includes(pathname) &&
        (commonMenuFlag
            ? window.location.search.includes("commonMenuFlag=true")
            : !window.location.search.includes("commonMenuFlag=true"))
    );
};

function Group({ item, depth }) {
    let [isOpen, setOpen] = useState(false);
    let match = isMatch(item.url);
    useEffect(() => {
        if (match) {
            setOpen(true);
        }
    }, []);

    let transform = `rotate(${isOpen ? 90 : 0}deg)`;
    return (
        <div className="group">
            <div
                className={`item ${match ? "active-sub" : ""}`}
                onClick={() => (item.list?.length === 0 ? openPage(item.url) : setOpen(!isOpen))}
                style={{ paddingLeft: `${24 * depth}px` }}>
                {depth === 1 && <span className="icon" dangerouslySetInnerHTML={{ __html: item.icon }} />}
                <span className={"title"}>{item.title}</span>
                {item.list?.length > 0 && (
                    <RightOutlined className="icon-down" style={{ fontSize: "14px", transform }} />
                )}
            </div>
            {isOpen &&
                item.list?.map((sub, key) => {
                    if (sub.list && sub.list.length > 0) {
                        return <Group item={sub} depth={depth + 1} key={key} />;
                    } else {
                        return (
                            <div
                                onClick={() => {
                                    if (sub.url.indexOf("http://") > -1 || sub.url.indexOf("https://") > -1) {
                                        openPage(sub.url);
                                    } else {
                                        openPage(item.url + sub.url);
                                    }
                                }}
                                className={`item ${isMatch(item.url + sub.url.split("?")[0]) ? "active" : ""}`}
                                key={key}
                                style={{ paddingLeft: `${24 * (depth + 1)}px` }}>
                                {sub.title}
                            </div>
                        );
                    }
                })}
        </div>
    );
}

function PopoverGroup({ item, depth }) {
    let subList = item.list || [item];
    return (
        <Popover
            placement={"right"}
            content={subList.map((sub, key) => {
                if (sub.list && sub.list.length > 0) {
                    console.log("menu sub.list", sub.list);
                    return <PopoverGroup item={sub} depth={depth + 1} key={key} />;
                } else {
                    return (
                        <div
                            onClick={() => {
                                if (sub.url.indexOf("http://") > -1 || sub.url.indexOf("https://") > -1) {
                                    openPage(sub.url);
                                } else {
                                    openPage(item.url + sub.url);
                                }
                            }}
                            className={`item ${isMatch(item.url + sub.url.split("?")[0]) && "active"}`}
                            key={key}>
                            {sub.title}
                        </div>
                    );
                }
            })}
            overlayClassName="react-single-app-popover">
            {(function () {
                if (depth > 1 && item.list && item.list.length > 0) {
                    return (
                        <div className={`item ${isMatch(item.url) && "active"}`} onClick={() => openPage(item.url)}>
                            {item.title}
                        </div>
                    );
                } else {
                    return (
                        <div className={`item ${isMatch(item.url) && "active"}`} onClick={() => openPage(item.url)}>
                            <span className="icon" dangerouslySetInnerHTML={{ __html: item.icon }} />
                        </div>
                    );
                }
            })()}
        </Popover>
    );
}

function Menu({ menuList }) {
    let [menuType, setMenuType] = useState(localStorage[`/style/menuType`] || "col");
    let [showFavoriteModal, setShowFavoriteModal] = useState(false);
    const favoriteMenuRef = useRef();

    const handleFavoriteSave = () => {
        // 通过 ref 调用子组件的刷新方法
        favoriteMenuRef.current?.refresh();
    };

    return (
        <div className="app-menu">
            <div className={`app-menu-main ${menuType}`}>
                <VerticalScroll style={{ width: menuType == "mini" ? "80px" : "218px", height: "100%" }}>
                    {/* 常用菜单 */}
                    <FavoriteMenu
                        ref={favoriteMenuRef}
                        menuType={menuType}
                        menuList={menuList}
                        onAddClick={() => setShowFavoriteModal(true)}
                    />
                    {/* 普通菜单 */}
                    {menuList.map((item, key) =>
                        menuType == "col" ? (
                            <Group key={key} item={item} menuType={menuType} depth={1} />
                        ) : (
                            <PopoverGroup key={key} item={item} depth={1} />
                        ),
                    )}
                </VerticalScroll>
            </div>
            <div
                className={`shrink`}
                onClick={() => {
                    let newType = menuType == "col" ? "mini" : "col";
                    setMenuType(newType);
                    localStorage[`/style/menuType`] = newType;
                }}>
                {menuType == "mini" ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            </div>
            {/* <div
                className={`shrink`}
                onClick={() => {
                    let newType = menuType == "col" ? "mini" : "col";
                    setMenuType(newType);
                    localStorage[`/style/menuType`] = newType;
                }}>
                {menuType == "mini" ? <ForwardOutlined /> : <BackwardOutlined />}
            </div>
            <div className="shrink">
                <Button type="primary"
                    onClick={() => {
                        let newType = menuType == "col" ? "mini" : "col";
                        setMenuType(newType);
                        localStorage[`/style/menuType`] = newType;
                    }} >
                    {menuType == "mini" ? <MenuUnfoldOutlined /> : <MenuUnfoldOutlined />}
                </Button> */}
            {/* 常用菜单管理弹窗 */}
            <FavoriteMenuModal
                visible={showFavoriteModal}
                onCancel={() => setShowFavoriteModal(false)}
                menuList={menuList}
                onSave={handleFavoriteSave}
            />
        </div>
    );
}

export default withRouter(Menu);
